export default __webpack_public_path__ + "img/2a550d1990fd3c593d14391d8a72dbf5.svg";